import { useEffect, useState } from 'react'
import { useNavigation } from 'react-router'

import { Spinner } from './Spinner'

export const RouterNavigationSpinner = () => {
    const { state } = useNavigation()

    const [shouldShowSpinner, setShouldShowSpinner] = useState(false)

    useEffect(() => {
        if (state === 'idle') {
            setShouldShowSpinner(false)
            return
        }

        const timeoutID = setTimeout(() => {
            setShouldShowSpinner(true)
        }, 400)

        return () => clearTimeout(timeoutID)
    }, [state])

    if (!shouldShowSpinner) {
        return null
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center">
            <div className="flex flex-col items-center justify-center gap-y-2 rounded-md bg-black/50 p-8">
                <div className="size-[128px]">
                    <Spinner />
                </div>
            </div>
        </div>
    )
}
